// Split out from impersonation.js so axiosInterceptors.js can import this key without a
// circular dependency (impersonation.js itself imports axiosInstance).
// Stored shape: { "token": "<admin's own real JWT>" }, stashed before overwriting
// localStorage.token with the impersonation token, and restored on exit/expiry.
export const ADMIN_SESSION_KEY = "adminSessionBeforeImpersonation";
